import CardCommon from '@/pages/opinion/components/CardCommon';
import {
  barHIcon,
  barSIcon,
  lineIcon,
  pieIcon,
  tableIcon,
} from '@/pages/opinion/constants/chart';
import React, { useState } from 'react';
import PieEchart from './PieEchart';
import LineEchart from './LineEchart';
import BarEchart from './BarEchart';
import { useIntl } from 'umi';
import { NO_DATE } from '@/pages/opinion/constants';
import BubbleCommon from '@/pages/opinion/components/BubbleCommon';
import DurationTable from './DurationTable';
import { downloadAction } from '@op/pages/download/utils';
import TwoBarEchart from './TwoBarEchart';

export default function GameDurationChart({
  pieChartData = [],
  timelineChartData = [],
  tableData = [],
  title = '',
  tipsMap = null,
  filter,
}: any) {
  const { formatMessage } = useIntl();
  const [chartType, setChartType] = useState<
    'line' | 'pie' | 'sentiment-h-bar' | 'table' | 'sentiment-s-bar'
  >('sentiment-s-bar');

  const getElementInfo = () => {
    switch (chartType) {
      case 'sentiment-h-bar':
        return <BarEchart height={358} data={pieChartData}></BarEchart>;
      case 'sentiment-s-bar':
        return <TwoBarEchart height={340} data={pieChartData}></TwoBarEchart>;
      case 'pie':
        return (
          <PieEchart
            height={340}
            chartData={pieChartData}
            pieLabelAlignTo
          ></PieEchart>
        );
      case 'table':
        return <DurationTable height={304} records={tableData}></DurationTable>;
      default:
        return (
          <LineEchart
            height={340}
            data={timelineChartData}
            filter={filter}
          ></LineEchart>
        );
    }
  };

  return (
    <CardCommon
      title={
        <>
          {formatMessage({ id: title || NO_DATE.EMPTY })}
          <BubbleCommon
            placement="top"
            childStyle={{ verticalAlign: 'middle' }}
            tipsMap={tipsMap}
          ></BubbleCommon>
        </>
      }
      contentCard
      hasDownload
      handleDownloadOnClick={() => {
        downloadAction({
          data: tableData,
          key: 'SteamInsightGameDurationTable',
          filter,
          fileName: title,
        });
      }}
      defaultOperation={chartType}
      operations={[barSIcon, barHIcon, lineIcon, pieIcon, tableIcon]}
      handleOperationsOnClick={({ symbol }: any) => setChartType(symbol)}
    >
      {getElementInfo()}
    </CardCommon>
  );
}
